//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import aos from "~/mixins/aos.js";
import foretell from "~/mixins/foretell.js";
import API from "~/api/api";
import {
  stateNameByValue,
  stateAbbreviationByValue,
  states,
} from "@/src/states";

export default {
  data() {
    return {
      stateID: "",
      state: "Alabama",
      showStatesDropdown: false,
      hide: false,
    };
  },
  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", {
        lander_test: "bp:compliance-guard",
      });
    }
  },
  mixins: [aos, foretell],

  head() {
    if (this.pageInfo && this.metaInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain;
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "compliance-guard-boi-032025", {
        preview: 1,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.log(e);
        error({ message: "Error fetching data..." });
        return {
          loading: false,
          // error: true,
        };
      });
  },
  computed: {
    defaultState() {
      return this.$store.state.user.data.defaultState;
      // return parseInt(this.$store.state.user.data.defaultState || "Alabama");
    },
    hero() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.hero;
    },
    features() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.features;
    },
    howto() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.how_to;
    },
    formation() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.formation;
    },
    faqs() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.faqs;
    },
    footercta() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.footer_cta;
    },
    metaInfo() {
      if (this.pageInfo && this.pageInfo.fields)
        return this.pageInfo.fields.meta_information.table;
    },
  },
  methods: {
    options() {
      return states.map(function(s) {
        return {
          value: s.value,
          text: s.label,
        };
      });
    },
    stateAbbreviationByValue(stateId) {
      return stateAbbreviationByValue(stateId);
    },
    stateNameByValue(stateId) {
      return stateNameByValue(stateId);
    },
    stateSelect(event) {
      this.stateID = event.target.value;
      this.state = this.stateNameByValue(this.stateID);
    },
  },
};
